export enum PropertySaleTypes {
  Undefined = 0,
  RealtyEscrow = 1,
  Foreclosure = 5,
  Telemarketing = 6,
  Resale = 7,
  DirectSale = 8,
  CMIDirect = 9,
  FSBO = 10,
  Refinance = 11,
  None = 12,
  CHWRollover = 15,
  HWSTerm2Plus = 17,
  BPGRollover = 18
}



// WEBPACK FOOTER //
// ./src/_constants/PropertySaleTypes.ts